import React from "react";
import { MailIcon, PhoneIcon } from "../../../components/CommonSvg";

export const FIXED_COLUMNS = [
    { key: "hraMemberId", label: "HRA Id" },
    { key: "storeNameRegular", label: "Store Name" },
    { key: "firstName", label: "Member" },
];

export const PAGE_SIZES = [10, 25, 50, 100];

export const memberName = (member) =>
    `${member?.firstName || ""} ${member?.lastName || ""}`.trim();

export const initials = (name) =>
    (name || "")
        .split(/[\s/]+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((word) => word[0])
        .join("")
        .toUpperCase() || "—";

const plain = (field) => (record) => record[field] || "—";

/* the vendor picks which of these ride along with the fixed three - the saved
   column config is a list of these keys */
export const OPTIONAL_COLUMNS = {
    emailAddress: {
        label: "Email",
        render: (record) => (
            <span className="vp-mwith-icon">
                <MailIcon />
                {record.emailAddress || "—"}
            </span>
        ),
    },
    phoneNumberMobileNumber: {
        label: "Business Phone Number",
        render: (record) => (
            <span className="vp-mwith-icon">
                <PhoneIcon />
                {record.phoneNumberMobileNumber || "—"}
            </span>
        ),
    },
    city: { label: "City", render: plain("city") },
    state: { label: "State", render: plain("state") },
    postalCode: { label: "Zip Code", render: plain("postalCode") },
    cokeBottlerRegion: {
        label: "Coke Bottler Region",
        render: plain("cokeBottlerRegion"),
    },
    rbnaDistributor: {
        label: "RBNA Distributor Name",
        render: plain("rbnaDistributor"),
    },
    managerTerritory: {
        label: "Field Manager Territory",
        render: plain("managerTerritory"),
    },
    status: {
        label: "Status",
        render: (record) => (
            <span
                className={`vp-status-pill ${record.status === "Active" ? "st-active" : "st-inactive"}`}
            >
                {record.status || "—"}
            </span>
        ),
    },
};

export const toColumns = (fields) =>
    fields
        .filter((field) => OPTIONAL_COLUMNS[field])
        .map((field) => ({ key: field, ...OPTIONAL_COLUMNS[field] }));
